import { useConnectionStatus } from "@/hooks/useConnectionStatus";

/**
 * Globaler Reconnect-Banner.
 * Zeigt sich, wenn die Phase-API ≥6s keine Antwort gibt.
 * Brief 04 Sektion G — "Verbindung verloren · reconnecting".
 */

export function ReconnectBanner() {
  const { online, retries } = useConnectionStatus(6_000);
  if (online) return null;
  return (
    <div
      role="alert"
      className="mono beacon-reconnect-banner"
      style={{
        // Inline im Dokument-Fluss → schiebt Sidebar/AppFrame nach unten
        // statt sie zu überlagern. Brief 04 Sektion G "Reconnect"-State.
        background: "var(--signal-error)",
        color: "var(--svo-weiss, #fff)",
        padding: "var(--s-2) var(--s-4)",
        fontFamily: "var(--font-mono)",
        fontSize: 12,
        letterSpacing: "var(--tracking-meta)",
        textTransform: "uppercase",
        textAlign: "center",
        boxShadow: "0 4px 16px rgba(229, 57, 53, 0.4)",
        position: "relative",
        zIndex: 9999,
      }}
    >
      VERBINDUNG VERLOREN · RECONNECTING · VERSUCH {retries}
    </div>
  );
}
